






































import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    showCloseBtn: { type: Boolean, default: false }
  },
  computed: {
    icons(): object {
      return {
        info: faInfoCircle,
        times: faTimes
      }
    },
    listItems() {
      return [
        this.$t(
          'you are not allowed to ask questions that can be registered as wanted classified (e.g where can i find an engine for rav4).'
        ),
        this.$t(
          'you should only add questions/answers related to the category you have chosen.'
        ),
        this.$t(
          'ensure that your questions/answers are really specific because car.gr reserves the right to remove them.'
        ),
        this.$t('never publish sensitive or other personal data.'),
        this.$t(
          'avoid personal questions/answers or directed against another member of the community.'
        )
      ]
    }
  }
})
